<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<!-- <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button> -->
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="ID" width="80" align="center">
				  <template slot-scope="scope">
					{{ scope.row.id }}
				  </template>
				</el-table-column>
				<el-table-column label="机构名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.tjjg_name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="体检项目" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.package_name }}
				  </template>
				</el-table-column>
				<el-table-column label="姓名" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.name }}
				  </template>
				</el-table-column>
				<el-table-column label="电话" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.phone }}
				  </template>
				</el-table-column>
				<el-table-column label="年龄" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.age }}
				  </template>
				</el-table-column>
				<el-table-column label="性别" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.gender === 1 ? '男' : '女' }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="60" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="160">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.utime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center">
				  <template slot-scope="scope">
					<!-- <el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip> -->
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
			 <el-form-item label="机构名称" prop="name">
			   <el-input v-model="form.name" placeholder="请输入机构名称" type="text" clearable />
			 </el-form-item>
			 <el-form-item label="联系电话" prop="mobile">
			   <el-input v-model="form.mobile" placeholder="请输入联系电话" type="text" clearable />
			 </el-form-item>
			 <el-form-item label="联系地址" prop="address">
			   <el-input v-model="form.address" placeholder="请输入联系地址" type="text" clearable />
			 </el-form-item>
			 <el-form-item label="封面Logo" prop="cover">
				 <div class="border rounded flex-all mr-3" style="width: 100px;height: 100px;line-height: 100px;cursor: pointer;"
				 @click="chooseImage"
				 >
				   <img :src="form.url" class="w-100 h-100" v-if="form.url">
				   <i class="el-icon-plus text-muted" style="font-size: 30px;" v-else></i>
				 </div>
			 </el-form-item>
		     <el-form-item  label="状态">
		      <el-radio-group v-model="form.status">
		      	<el-radio :label="1">使用</el-radio>
		      	<el-radio :label="2">停用</el-radio>
		      </el-radio-group>
		     </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'tjyy',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				list:[],
				tree:[],
				form:{
					name: '',
					mobile: '',
					address: '',
					sort:100,
					status:1,
					cover:'',
					url:'',
				},
				rules:{
					name: [
					  { required: true, message: '请输入菜单名称', trigger: 'blur' }
					],
				},
			}
		},
		mounted() {
			
		},
		methods:{
			getList() {
				this.loading = true
				this.axios.get(`/manage/${this.preUrl}/list`, {
				  params: this.queryForm
				}).then(res => {
				  this.total = res.total
				  this.list = res.data
				  this.tree = res.tree
				  this.loading = false
				}).catch(err => {
				  this.loading = false
				})
			},
			reset() {
			  this.form = {
				    name: '',
					mobile: '',
					address: '',
					sort:100,
					status:1,
					cover:'',
					url:'',
			  }
			  this.resetForm('form')
			},
			chooseImage(){
				this.app.chooseImage((res)=>{
				  this.form.cover = res[0].id
				  this.form.url = res[0].url
				})
			},
		}
	}
</script>

<style>
</style>